import { render, staticRenderFns } from "./LoanPublicInfo.vue?vue&type=template&id=47c9699a"
import script from "./LoanPublicInfo.vue?vue&type=script&lang=js"
export * from "./LoanPublicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports